import './DataTableV2.css';
export var dataTableV2CSS = '_wgog2z0-2-0-1';
export var dataTableV2FullWidthCSS = '_wgog2z1-2-0-1';
export var dataTableV2InteractiveRows = '_wgog2z3-2-0-1';
export var dataTableV2NotResizingCSS = '_wgog2z2-2-0-1';